<template>
    <div id="menucategory-wrapper">
        <div class="cat"
             :class="category.slug"
             v-if="category.children"
        ><a :href="category.url"
            @click.prevent="showChildren = !showChildren"
            v-html="addWordBreaks(category.name)"
        ></a>
            <span class="arrowicon">&nbsp;</span>
        </div>
        <div class="cat" v-if="!category.children">
            <a :href="category.url" v-html="addWordBreaks(category.name)"></a>
        </div>
        <ul v-if="showChildren" class="subcatside">
            <li v-for="child in category.children" v-if="!child.hide_from_menu">
                <a :href="child.url" v-html="addWordBreaks(child.name)"></a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['category'],
        data(){
            return {
                showChildren: false,
            }
        },

        methods: {
            addWordBreaks(categoryName) {
                return categoryName.replace('/', '/<wbr>');
            }
        }
    }
</script>
